import { LOGOS } from "../lib/logos";

/**
 * Soul Trip — official painted wordmark (white on transparent PNG).
 * Default usage shows as-is; pass `tint="gold"` for a subtle gold gradient via CSS mask.
 */
export const SoulTripWordmark = ({ height, className = "", style = {}, tint = "white", ...rest }) => {
  if (tint === "gold") {
    return (
      <div
        role="img"
        aria-label="Soul Trip"
        className={className}
        style={{
          ...(height ? { height } : {}),
          aspectRatio: "4 / 3",
          background: "linear-gradient(135deg, #FFE08A 0%, #E8C56A 22%, #C9A04A 55%, #8E6B22 100%)",
          WebkitMaskImage: `url(${LOGOS.soulTripMark})`,
          maskImage: `url(${LOGOS.soulTripMark})`,
          WebkitMaskRepeat: "no-repeat",
          maskRepeat: "no-repeat",
          WebkitMaskSize: "contain",
          maskSize: "contain",
          WebkitMaskPosition: "center",
          maskPosition: "center",
          display: "inline-block",
          ...style,
        }}
        {...rest}
      />
    );
  }

  // Default — render the official transparent PNG as a bare <img>.
  // When height is omitted, sizing is fully controlled by className (responsive).
  return (
    <img
      src={LOGOS.soulTripMark}
      alt="Soul Trip"
      className={className}
      draggable={false}
      style={{
        ...(height ? { height } : {}),
        width: "auto",
        background: "transparent",
        ...style,
      }}
      {...rest}
    />
  );
};

/**
 * Gandabherunda Arts double-headed eagle — official PNG.
 */
export const GandabherundaMark = ({ size = 36, className = "", style = {}, ...rest }) => (
  <img
    src={LOGOS.gandabherunda}
    alt="Gandabherunda Arts"
    width={size}
    height={size}
    className={className}
    style={{ objectFit: "contain", display: "block", ...style }}
    {...rest}
  />
);
